export default __webpack_public_path__ + "static/media/Screenshot_4-1727273357231.d9e43fef.jpg";